import { FaFireExtinguisher, FaTools, FaCheckCircle, FaClock, FaChartLine, FaGavel } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the BlazeGuard Brigade with Purpose",
    description: "At BlazeGuard, we're looking for dedicated individuals to join our firefighting team. Explore fulfilling career opportunities in fire safety and emergency response. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Explore Opportunities in Fire Safety",
        "Assist in Emergency Response Operations",
        "Firefighting Skills Development Programs",
        "Emergency Situation Management",
        "Support in Fire Prevention Programs",
    ],
};

const benefits = [
    {
        id: 1,
        icon: <FaFireExtinguisher />,
        title: "Firefighting Expertise",
        description:
        "Enhance your firefighting expertise within our collaborative team. Work in an environment that values firefighting excellence.",
    },
    {
        id: 2,
        icon: <FaTools />,
        title: "Skill Enhancement",
        description:
        "Benefit from skill development opportunities to advance your expertise in various aspects of fire safety and emergency response.",
    },
    {
        id: 3,
        icon: <FaCheckCircle />,
        title: "Quality Standards",
        description:
        "Uphold the highest quality standards in every firefighting operation. Ensure excellence in fire safety services.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Efficient Processes",
        description:
        "Contribute to streamlined and efficient firefighting operations. Maximize productivity while maintaining the highest standards of fire safety.",
    },
    {
        id: 5,
        icon: <FaChartLine />,
        title: "Team Advancement",
        description:
        "Enjoy opportunities for career advancement and personal growth within our dynamic fire safety work environment.",
    },
    {
        id: 6,
        icon: <FaGavel />,
        title: "Ethical Practices",
        description:
        "Contribute to upholding the highest standards of ethics and integrity in our firefighting initiatives and services.",
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Firefighter',
        details: {
            location: 'Fire Department, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 4 Years in Firefighting',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'Emergency Services: 911',
        },
        overviews: [
            'We are seeking a dedicated Firefighter to join our firefighting team. As a Firefighter, you will play a crucial role in ensuring public safety and responding to emergency situations. If you have a strong sense of duty and are physically fit, we invite you to be a part of our firefighting force.',
        ],
        responsibilities: [
            'Responding promptly to fire and emergency calls.',
            'Performing fire suppression and rescue operations.',
            'Operating firefighting equipment and vehicles.',
            'Participating in fire prevention and safety programs.',
            'Conducting inspections to ensure compliance with safety regulations.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Physical fitness and agility.',
            'Ability to work in high-stress and physically demanding situations.',
            'Teamwork and communication skills.',
            'Completion of firefighter training program (if applicable).',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Fire Safety Officer',
        details: {
            location: 'Fire Department, City',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Relevant Experience Required',
            position: 'Single Position Available',
            days: 'Monday to Friday',
            salary: '$70,000 - $85,000',
            deadline: 'Apply Now - Open Until Filled',
            number: 'Emergency Services: 911',
        },
        overviews: [
            'As a Fire Safety Officer, your main duty will be to ensure fire prevention policies and procedures are implemented effectively. This role involves regular inspections, training sessions, and emergency response planning to reduce risks and safeguard lives and property.',
        ],
        responsibilities: [
            'Develop and implement fire safety plans and protocols.',
            'Conduct fire drills, inspections, and safety audits.',
            'Ensure compliance with local fire safety regulations and codes.',
            'Train staff on fire prevention, evacuation, and emergency response.',
            'Collaborate with emergency services during incidents and investigations.',
        ],
        qualifications: [
            'Bachelor’s degree in Fire Science, Safety, or a related field (preferred).',
            'Knowledge of fire safety codes and regulations.',
            'Strong communication and organizational skills.',
            'Experience in emergency planning and risk assessment.',
            'Fire safety certification or training is a plus.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Emergency Response Specialist',
        details: {
            location: 'Fire Department, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Availability Required',
            experience: 'Minimum 5 Years in Emergency Response',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$80,000 - $95,000',
            deadline: 'Apply Now - Open Until Filled',
            number: 'Emergency Services: 911',
        },
        overviews: [
            'As an Emergency Response Specialist, you will be responsible for rapid assessment, coordination, and execution of emergency plans. This position demands excellent problem-solving skills, calm under pressure, and the ability to lead during high-stakes scenarios.',
        ],
        responsibilities: [
            'Respond promptly to fire, medical, and hazardous material emergencies.',
            'Coordinate with multiple agencies during crisis operations.',
            'Maintain up-to-date knowledge of emergency response procedures.',
            'Conduct training and drills to ensure preparedness.',
            'Evaluate emergency situations and determine the best course of action.',
        ],
        qualifications: [
            'Proven experience in emergency services or disaster response.',
            'Strong leadership and crisis management skills.',
            'Ability to remain calm and effective under pressure.',
            'Certification in EMT, HazMat, or related emergency training preferred.',
            'Excellent communication and decision-making abilities.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Fire Prevention Officer',
        details: {
            location: 'Fire Department, City',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 4 Years in Fire Safety or Inspection',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$75,000 - $90,000',
            deadline: 'Apply Now - Open Until Filled',
            number: 'Emergency Services: 911',
        },
        overviews: [
            'As a Fire Prevention Officer, you will be tasked with enforcing fire safety regulations, conducting inspections, and promoting fire prevention through educational outreach. This is a critical role focused on protecting lives and property before emergencies occur.',
        ],
        responsibilities: [
            'Inspect buildings and properties for fire hazards and code compliance.',
            'Educate the public on fire prevention practices and safety measures.',
            'Issue permits and citations for fire safety violations.',
            'Investigate fire incidents to determine cause and recommend preventive actions.',
            'Collaborate with fire departments, schools, and community organizations.',
        ],
        qualifications: [
            'Experience in fire safety, code enforcement, or fire inspection.',
            'Strong knowledge of local fire codes and regulations.',
            'Excellent communication and public speaking skills.',
            'Certification in Fire Prevention or Fire Inspector training preferred.',
            'Attention to detail and investigative abilities.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Rescue Specialist',
        details: {
            location: 'Fire Department, City',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 4 Years in Emergency Rescue',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$70,000 - $85,000',
            deadline: 'Apply Now - Open Until Filled',
            number: 'Emergency Services: 911',
        },
        overviews: [
            'As a Rescue Specialist, you will respond to complex and high-stakes rescue operations including building collapses, vehicular accidents, water rescues, and confined space extractions. Your expertise and quick action will make the difference in life-threatening situations.',
        ],
        responsibilities: [
            'Respond rapidly to rescue calls involving hazardous environments.',
            'Utilize advanced rescue tools and techniques for extrication and stabilization.',
            'Coordinate with firefighting and EMS teams on scene.',
            'Conduct regular drills and maintain readiness for all types of rescue missions.',
            'Ensure proper use and maintenance of rescue equipment.',
        ],
        qualifications: [
            'Extensive experience in technical or urban search and rescue.',
            'Strong physical fitness and stamina.',
            'Training in rope rescue, confined space, and water rescue techniques.',
            'Excellent situational awareness and decision-making skills.',
            'Certifications in rescue operations and emergency response preferred.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Fire Investigation Officer',
        details: {
            location: 'Fire Department, City',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 5 Years in Fire Investigation',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$85,000 - $100,000',
            deadline: 'Apply Now - Open Until Filled',
            number: 'Emergency Services: 911',
        },
        overviews: [
            'As a Fire Investigation Officer, you will be responsible for analyzing fire scenes, collecting evidence, and determining the cause of fires. You will work closely with law enforcement and insurance companies to provide accurate reports and findings.',
        ],
        responsibilities: [
            'Conduct detailed investigations at fire scenes to determine the cause and origin of the fire.',
            'Collect and preserve evidence for legal proceedings.',
            'Work with law enforcement, insurance companies, and other agencies during investigations.',
            'Prepare comprehensive reports and testimonies for court if needed.',
            'Stay updated on fire investigation techniques and best practices.',
        ],
        qualifications: [
            'Experience in fire scene analysis and investigation.',
            'Knowledge of fire behavior, fire dynamics, and related investigative techniques.',
            'Strong attention to detail and analytical skills.',
            'Excellent written and verbal communication skills.',
            'Fire Investigation Certification or related credentials preferred.',
        ],
    }

];

export { positions, benefits, careerIntro };